import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";

const faqs = [
  { q: "Which areas do you service?", a: "The entire Sunshine Coast — Noosa, Caloundra, Maroochydore, Mooloolaba and all surrounding suburbs. Travel beyond 40km from the coast may attract a small fee, confirmed in your quote." },
  { q: "How far in advance should I book?", a: "We recommend at least 2 weeks' notice, and 4-6 weeks for peak summer weekends and weddings. Get in early to secure your date." },
  { q: "Do you supply the alcohol?", a: "Packages cover your signature cocktail menu. Bottled drinks and cans are available on request, and we're happy to advise on quantities and BYO arrangements to suit your event." },
  { q: "What do you need on the day?", a: "Just a flat space for the bar and access to the setup area. The bar, tools, ice, glassware and everything else arrives with your bartender — fully self-contained." },
  { q: "Is it really just one bartender?", a: "Yes — every package is delivered personally by one experienced bartender, which keeps the service intimate, consistent and beautifully hands-on. Guest counts and timings are scaled to match." },
  { q: "How is pricing calculated?", a: "Pricing scales with your guest count, with a minimum booking floor per package. Use the live Quote Calculator for an instant estimate, then submit an enquiry to lock it in." },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-seafoam py-24 md:py-32">
    <div className="max-w-5xl mx-auto px-5 md:px-8">
      <Reveal className="mb-14 text-center">
        <p className="overline text-xs text-coral mb-5">Good to Know</p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ocean-deep leading-[1.02] tracking-tight">
          Frequently asked questions
        </h2>
      </Reveal>

      <Reveal>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-ocean/15">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-serif text-xl md:text-2xl text-ocean-deep hover:text-coral hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-ocean/80 text-base leading-relaxed pb-6 max-w-3xl">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
